/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Accounts from './Accounts/index'
import No from './No/index'
import Preferred from './Preferred/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CreateIteroScanRequest/Content/Content/Step/Account/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let accountSettingsViewValueData = fromData.useDataValue({ viewPath,
context: 'account_settings',
path: 'view',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: accountSettingsViewValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Preferred'}>
<Preferred
  viewPath={`${viewPath}/Preferred`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Accounts'}>
<Accounts
  viewPath={`${viewPath}/Accounts`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}